import './App.css';
import logo from './final_logo.png';

function App() {
  return (
    <div className="App cinematic">
      <div className="ambient-glow" />

      <main className="center-stage">
        <img
          src={logo}
          alt="Moral Cinemas"
          className="studio-logo"
        />

        <div className="announcement">
          <span className="line" />
          <h1 className="coming-soon">COMING SOON</h1>
          <span className="line" />
        </div>

        <p className="release-tag">A New World of Family Cinema</p>
      </main>

      <footer className="quiet-footer">
        © 2026 MORAL CINEMAS
      </footer>
    </div>
  );
}

export default App;
